<section class="flow-products">
  <div class="textures">
    <img src="/assets/solutions/solutions--txtr-why-flow-lower.svg" class="lower" alt=""/>
    <img src="/assets/solutions/solutions--txtr-why-flow-upper.svg" class="upper"  alt=""/>
  </div>
  <div id="products" class="product-fold">
    <h1>Our Products</h1>
    <p>
      Eliminate errors, paperwork and administrative tasks by leveraging Flow to raise pools of capital and manage
      ongoing fund administration.
    </p>
  </div>
  <div class="product-cards-container">
    <fl-product-card [product]="{
      title: 'Investor Onboarding',
      image: '/assets/home/product/investor-onboarding.svg',
      content: 'Simplify investor onboarding and fund subscriptions for GPs, LPs and law firms.',
      expandedList: [
        {
        color: 'mango-tint-60',
        icon: '/assets/home/product/cards-v2.svg',
        content: 'Digitize the LP onboarding process.'
        },
        {
        color: 'mango-tint-60',
        icon: '/assets/home/product/text-v2.svg',
        content: 'Transparently manage the subscription process with LPs.'
        },
        {
        color: 'mango-tint-60',
        icon: '/assets/home/product/chart-v2.svg',
        content: 'Generate structured data that will help you run your fund.'
        },
      ]
    }"></fl-product-card>
    <fl-product-card [product]="{
      title: 'Investor Portal',
      image: '/assets/home/product/investor-portal.svg',
      content: 'Manage distribution and collection of information across GPs, LPs and fund administrators.',
      expandedList: [
        {
        color: 'mango',
        icon: '/assets/home/product/cards-v2.svg',
        content: 'Seamlessly integrate your fund administrator and related providers.'
        },
        {
        color: 'mango',
        icon: '/assets/home/product/text-v2.svg',
        content: 'Efficiently distribute reports, capital calls and investor updates.'
        },
        {
        color: 'mango',
        icon: '/assets/home/product/chart-v2.svg',
        content: 'Manage and collect investor information for compliance and audit confirmations.'
        },
      ]
    }"></fl-product-card>
    <fl-product-card [product]="{
      title: 'SPVs',
      image: '/assets/home/product/spvs.svg',
      content: 'Execute and scale SPV strategies independent of or integrated with flagship funds.',
      expandedList: [
        {
        color: 'cucumber-tint-60',
        icon: '/assets/home/product/cards-v2.svg',
        content: 'End-to-end SPV creation and management.'
        },
        {
        color: 'cucumber-tint-60',
        icon: '/assets/home/product/text-v2.svg',
        content: 'Utilize Flow\'s technology platform and partnership network.'
        },
        {
        color: 'cucumber-tint-60',
        icon: '/assets/home/product/chart-v2.svg',
        content: 'Use Flow\'s subscription document templates.'
        },
      ]
    }"></fl-product-card>
  </div>
</section>
